import type { Feedback } from "@/mocks/admin/feedback";

type Props = {
  feedback: Feedback[];
};

export default function CustomerFeedback({ feedback }: Props) {
  if (feedback.length === 0) {
    return (
      <div className="bg-white border border-ink-100 rounded-lg">
        <div className="px-5 py-3 border-b border-ink-100">
          <h3 className="font-display text-sm font-bold text-ink-900">Feedback</h3>
        </div>
        <div className="py-10 text-center">
          <div className="w-10 h-10 rounded-full bg-cream-100 text-ink-400 mx-auto flex items-center justify-center mb-2">
            <i className="ri-chat-3-line"></i>
          </div>
          <div className="text-xs text-ink-500">No reviews from this customer yet.</div>
        </div>
      </div>
    );
  }

  const avg = feedback.reduce((s, f) => s + f.rating, 0) / feedback.length;

  return (
    <div className="bg-white border border-ink-100 rounded-lg">
      <div className="px-5 py-3 border-b border-ink-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h3 className="font-display text-sm font-bold text-ink-900">Feedback</h3>
          <span className="text-[10px] font-bold bg-cream-100 text-ink-700 px-1.5 py-0.5 rounded">
            {feedback.length}
          </span>
        </div>
        <div className="inline-flex items-center gap-1 text-xs font-bold text-amber-600">
          <i className="ri-star-fill"></i>
          <span className="tabular-nums">{avg.toFixed(1)}</span>
          <span className="text-ink-400 font-normal">avg</span>
        </div>
      </div>

      <ul className="divide-y divide-ink-100">
        {feedback.slice(0, 4).map((f) => (
          <li key={f.id} className="px-5 py-3.5">
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-0.5 text-amber-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={
                      i < f.rating
                        ? "ri-star-fill text-sm"
                        : "ri-star-line text-sm text-ink-200"
                    }
                  ></i>
                ))}
              </div>
              <span className="text-[10px] text-ink-400 font-mono">{f.projectId}</span>
            </div>
            <div className="text-sm font-bold text-ink-900 mb-0.5">{f.title}</div>
            <div className="text-xs text-ink-600 leading-relaxed line-clamp-2">
              {f.body}
            </div>
            <div className="text-[10px] text-ink-400 mt-1.5">
              {f.date} · {f.source}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}